import React from 'react';
import './pointer.less';

export interface PointerProps extends React.HTMLAttributes<HTMLDivElement> {
    prefixCls?: string;
    left?: string;
    top?: string;
    id?: string;
    active: boolean;
    activePointer?: any;
    color?: string;
}

// const BOXSHADOW = 'rgb(0 0 0 / 37%) 0px 1px 4px 0px';

export const Pointer = ({ className, prefixCls, left, top, id, active, color }: PointerProps): JSX.Element => {
    const style: React.CSSProperties = {
        position: 'absolute',
        left,
        // top: '-18px',
    };
    return (
        <div id={id || ''} className={`${prefixCls}-pointer ${className || ''}`} style={{ ...style }}>
            <div
                className={`${prefixCls}-fill gradient-pointer ${active ? 'active' : ''}`}
                style={{
                    width: 20,
                    height: 20,
                    transform: left ? 'translate(-10px, 0px)' : 'translate(-1px, -9px)',
                    border: '3px solid #fff',
                    borderRadius: 2,
                    backgroundColor: '#fff',
                }}
            >
                <div
                    style={{
                        width: 14,
                        height: 14,
                        backgroundColor: color,
                        borderRadius: 2,
                        overflow: 'hidden',
                        border: '1px solid rgba(0, 0, 0, 0.08)',
                    }}
                ></div>
            </div>
        </div>
    );
};
